var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 273,
    height: 111,
    viewBox: "0 0 273 111",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2643 -38.0997L37.2463 -20.4648C82.3069 32.5749 104.837 59.0948 135.313 61.5735C165.789 64.0523 192.309 41.522 245.348 -3.53856L271.612 -25.8509",
    stroke: "url(#paint0_linear_167_1031)",
    strokeOpacity: 0.2,
    strokeWidth: 1.27273
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0724 -28.5914L26.0544 -10.9565C71.115 42.0832 93.6454 68.6031 124.121 71.0818C154.597 73.5606 181.117 51.0303 234.157 5.96968L261.539 -17.2934",
    stroke: "url(#paint1_linear_167_1031)",
    strokeOpacity: 0.2,
    strokeWidth: 1.27273
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 -20.0343L15.982 -2.39934C61.0427 50.6403 83.573 77.1602 114.049 79.639C144.525 82.1177 171.044 59.5874 224.084 14.5269L250.347 -7.78551",
    stroke: "url(#paint2_linear_167_1031)",
    strokeOpacity: 0.2,
    strokeWidth: 1.27273
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_167_1031",
    x1: 235.502,
    y1: -68.3542,
    x2: 188.142,
    y2: 69.6613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341C7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE99EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_167_1031",
    x1: 81.0207,
    y1: -88.017,
    x2: 191.591,
    y2: 42.1321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341C7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE99EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_167_1031",
    x1: 70.3887,
    y1: -78.9845,
    x2: 180.959,
    y2: 51.1647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341C7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE99EC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerBackground);
export default __webpack_public_path__ + "static/media/bannerBackground.b25153642770869920c7ebae9812b899.svg";
export { ForwardRef as ReactComponent };